import { ModuleExtensions } from '@wix/premium-fed-sdk/@premium-module';
export const EntriIntroDataHooksExtension = ModuleExtensions.dataHooksExtension(['entri-intro-modal', 'manualBtn', 'continueBtn', 'supportLink']);
//# sourceMappingURL=EntriIntroDataHooksExtension.js.map